import { getSeatingPreferences } from "../../../app/api/getSeatingPreferences";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ISeatingPreference } from "../../../Orchestrator/Types/Interface/ISeatingPreference";

class GetSeatingPreferencesAction extends BaseAction<ISeatingPreference | null, void> {
  protected override async run(): Promise<ISeatingPreference | null> {
    let seatingPreferences: ISeatingPreference | null = null;
    try {
      const response = await getSeatingPreferences();
      if (response.status === "ok" && response.answer) {
        const seatingPreference = response.answer;
        if (seatingPreference) {
          seatingPreferences = seatingPreference;
          updateRecoilState("seatingPreferencesAtom", seatingPreferences);
        } else {
          console.warn("Not available.");
        }
      } else {
        console.warn("Failed to data.");
      }

    } catch (error: any) {
      console.error("Error fetching data:", error);
    } finally {
      return seatingPreferences;
    }
  }
}

export const getSeatingPreferencesAction = new GetSeatingPreferencesAction();
